// Custom html attribute that help to interpret custom variables (need to begin with "data-" and accepter in sanitizer)
export const VARIABLE_DATA_ATTR = "data-custom-variable";
export const PREFILLED_FORM_ID = "data-prefilled-form-id";
export const PREFILLED_FORM_TYPE = "data-prefilled-form-type";
export const VARIABLE_TEXT = "data-text";
export const CUSTOM_LINK = "data-custom-link";
export const BUTTON_COLOR = "data-button-color";
// Custom key that are added to the html values to differentiate different types of variables
export const MAGICAL_LINK_KEY = "magical-link-variable";
export const PREFILLED_FORM_KEY = "prefilled-form-variable";
export const E_TICKET_KEY = "e-ticket-variable";
// Kept start date variable name for backward compatibility
export const DATE_KEY = "date-variable";
export const END_DATE_KEY = "end-date-variable";
export const LOCATION_KEY = "location-variable";
// Custom key for button
export const FORM_LINK_BUTTON_KEY = "form-link-button";
export const CUSTOM_LINK_KEY = "custom-link-button";
